import type { AxiosRequestConfig } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';

import { fetchPage } from 'modules/app/sagas/resolveAll';
import type { ApiError, PageContent } from 'modules/global/generic.types';

import * as integrationsActions from './actions';
import * as types from './actionTypes';
import type { DmsProvider, FetchDmsProvidersRequestAction } from './types';

function* fetchDmsProvidersWorker(action: FetchDmsProvidersRequestAction) {
  const { request } = action.payload;

  try {
    const data: PageContent<DmsProvider> = yield* fetchPage<DmsProvider>(request as AxiosRequestConfig);
    yield put(integrationsActions.fetchDmsProvidersSuccess(data, action.meta));
  } catch (error) {
    yield put(integrationsActions.fetchDmsProvidersFailure(error as ApiError, action.meta));
  }
}

export default function* integrationsSagas() {
  yield takeLatest(types.FETCH_DMS_PROVIDERS_REQUEST, fetchDmsProvidersWorker);
}
